module.exports = __webpack_public_path__ + "static/img/1.e1c5e5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/1.png
// module id = hiYU
// module chunks = 0